import { Middleware, isRejectedWithValue } from '@reduxjs/toolkit';
import { toast } from '../toast';

export const ToastrMiddleware: Middleware = (api) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    console.error('error', action);

    let errorMessage = action?.payload?.data?.message;

    if (!errorMessage) {
      errorMessage = 'An error occurred';
    }

    toast({
      status: 'error',
      title: 'An error occurred',
      description: errorMessage,
      duration: 10000,
    });
  }

  return next(action);
};
